import { useState, useEffect, useRef } from 'react'
import { Portal, Logo, Button } from "components"
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { checkedCountState, selectedOrgsState, certFromState } from 'views/data/states.js'
import { useNavigate } from 'react-router-dom'
import layerStyles from 'css/Layer.module.css'

const FloatLayer = ({ data, setCheck }) => {

	const checkedCount = useRecoilValue(checkedCountState)
	const setSelectedOrgsState = useSetRecoilState(selectedOrgsState)
	const [showDrawer, setShowDrawer] = useState(false)
	const drawer = useRef()
	const navigate = useNavigate()
	const setCertFrom = useSetRecoilState(certFromState)

	const removeItem = insttCd => {
		setCheck(insttCd)
	}

	const setDrawerHeight = count => {
		let h
		if (count === 0) {
			h = 0
			setShowDrawer(false)
		} else {
			const div = drawer.current.querySelector("div")
			h = `${div.getBoundingClientRect().height}px`
		}
		drawer.current.style.height = h
	}

	const onCloseToggle = () => {
		toggleDrawer()
	}

	const onNext = () => {
		const orgs = []
		data.forEach(group => {
			group.data.forEach(item => {
				if (item.checked) orgs.push(item)
			})
		})
		setCertFrom("link")
		setSelectedOrgsState(orgs)
		navigate("certSelect")
	}

	const toggleDrawer = off => {
		const div = drawer.current.querySelector("div")
		let h, t
		if (typeof off === "boolean") {
			h = "6rem"
			t = off
		} else if (showDrawer) {
			h = 0
			t = false
		} else {
			h = `${div.getBoundingClientRect().height}px`
			t = true
		}
		setShowDrawer(t)
		drawer.current.style.height = h
	}

	useEffect(() => {
		let className = layerStyles.drawer
		if (className.indexOf(" ")) {
			className = className.split(" ").join(".")
		}
		const holder = drawer.current.closest(`.${className}`)
		if (holder) {
			if (checkedCount === 0) {
				holder.classList.add(layerStyles.hide)
			} else {
				holder.classList.remove(layerStyles.hide)
			}
		}
		if (showDrawer) setDrawerHeight(checkedCount)
	}, [checkedCount])

	return (
		<Portal>
			{
				<div className={layerStyles.drawer}>
					<div className={layerStyles.title} onClick={toggleDrawer}>
						<div>연결하는 기관 <strong className="text-blue ml_10">{checkedCount}</strong></div>
						<div className="drag-btn" />
					</div>
					<div ref={drawer} className={`${layerStyles.wrap} ${layerStyles.withTitle}`} style={{ height: 0, maxHeight: "85vh", overflowY: "auto" }}>
						<div>
							<ul className="check-area">
								{
									data &&
									data.map((group, index) => {
										if (group.checkedCount > 0) {
											return (
												<li key={index}>
													<div className="check-title">{group.indstNm} <span>{group.checkedCount}</span></div>
													{
														group.data.map(item => {
															if (item.checked) {
																return <List item={item} key={item.insttCd} removeItem={removeItem} />
															}
														})
													}
												</li>
											)
										}
									})
								}
							</ul>
						</div>
					</div>
					<i className={`icon_arrow_top absolute ${showDrawer ? "bottom" : ""} ${layerStyles.withTitle}`} style={{ top: "4.2rem", right: "3rem" }} onClick={onCloseToggle} />
					<div className="button-group">
						<Button className="btn btn--big btn-layer" disabled={!checkedCount} onClick={onNext}>다음</Button>
					</div>
				</div>
			}
		</Portal>
	)
}

const List = ({ item, removeItem }) => {
	return (
		<div className="check-list no-scroll">
			<div>
				<div>
					<div className="img-box img-symbol">
						<Logo code={item.insttCd} style={{ border: "1px solid #d9d9d9", borderRadius: "50%" }} />
					</div>
					<p className="ml_10 ellipsis" style={{ width: "17rem" }}>{item.insttNm}</p>
				</div>
				<i className="icon icon_list_close" onClick={() => removeItem(item.insttCd)} />
			</div>
		</div>
	)
}

export default FloatLayer